import { PrimaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import classnames from "classnames/bind";

import styles from "./AddToBasketButton.module.scss";

const cx = classnames.bind(styles);

type AddToBasketButtonProps = {
  disabled: boolean;
  isSubmitting: boolean;
  handleAddToBasketClick: () => void;
  buttonText?: string;
  ref?: React.Ref<HTMLButtonElement>;
  className?: string;
};

export const AddToBasketButton = ({
  disabled,
  handleAddToBasketClick,
  isSubmitting,
  buttonText = "Add to basket",
  ref,
  className,
}: AddToBasketButtonProps) => {
  return (
    <PrimaryButton
      // small hack for TS not understanding the ref passed to button
      {...(ref ? { ref } : {})}
      className={cx("button", className)}
      disabled={disabled}
      submitting={isSubmitting}
      onClick={handleAddToBasketClick}
      data-testid="basket:add"
    >
      {buttonText}
    </PrimaryButton>
  );
};
